var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "text-truncate",
      attrs: { title: _vm.object[_vm.columnKey] },
    },
    [_vm._v("\n  " + _vm._s(_vm.object[_vm.columnKey]) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }